import type { MouseEvent, RefObject } from "react";
import { getCountryFlagUrl } from "assets/icons/flagUrls";
import cn from "classnames";
import { COUNTRIES_LIST } from "constants/countries";
import { SITE_NAME } from "constants/siteName";
import { useSiteName } from "context/SiteName.context";
import styles from "./CountriesSelectList.module.scss";

type SelectCountriesListProps = {
  countries: string[];
  filteredCountries: string[] | null;
  state: {
    selectedIndex: number;
  };
  onSelectCountry: (e: MouseEvent<HTMLLIElement>) => void;
  currentItemRef: RefObject<HTMLLIElement>;
};

export const CountriesSelectList = ({
  countries,
  filteredCountries,
  state,
  onSelectCountry,
  currentItemRef,
}: SelectCountriesListProps) => {
  const { siteName } = useSiteName();
  const isChineseBrothers = siteName === SITE_NAME.CHINESE_BROTHERS;

  const itemsList = (filteredCountries ? filteredCountries : countries).map((countryName, index) => {
    const countryCode = COUNTRIES_LIST.find((c) => c.name === countryName)?.countryCode;
    const flagSrc = countryCode ? getCountryFlagUrl(countryCode) : undefined;
    return (
      <li
        key={countryName}
        aria-pressed={index === state.selectedIndex}
        tabIndex={0}
        className={styles.item}
        onClick={(e) => onSelectCountry(e)}
        ref={index === state.selectedIndex ? currentItemRef : null}
      >
        <img className={styles.itemFlag} src={flagSrc} alt="flagIcon" />
        <span className={styles.itemName}>{countryName}</span>
      </li>
    );
  });
  return (
    <ul
      className={cn(styles.list, {
        [styles.listChineseBrothers]: isChineseBrothers,
      })}
    >
      {!!itemsList.length ? itemsList : <li className={styles.itemNotFound}>Nothing found</li>}
    </ul>
  );
};
